import { MemoryBus } from "../interfaces/memory-bus";
import { Logger } from "./logger";

export function padHex(value: number, width: number): string {
    const hex = value.toString(16).toUpperCase();
    return '0'.repeat(Math.max(0, width - hex.length)) + hex;
}

export class MemoryAccess {
    private bus: MemoryBus;
    private getSP: () => number;
    private setSP: (value: number) => void;
    private logger: Logger;

    constructor(bus: MemoryBus, getSP: () => number, setSP: (value: number) => void, logLevel: number = 0) {
        this.bus = bus;
        this.getSP = getSP;
        this.setSP = setSP;
        this.logger = new Logger('MEM', logLevel);
    }

    setLogLevel(level: number): void {
        this.logger.setLogLevel(level);
    }

    read(address: number): number {
        const addr = address & 0xFFFF;
        const value = this.bus.read(addr);
        this.logger.log(3, () => `Read 0x${padHex(value, 2)} from address 0x${padHex(addr, 4)}`);
        return value;
    }

    write(address: number, value: number) {
        const addr = address & 0xFFFF;
        const val = value & 0xFF;
        this.bus.write(addr, val);
        this.logger.log(3, () => `Write 0x${padHex(val, 2)} to address 0x${padHex(addr, 4)}`);
    }

    read16(address: number): number {
        const lo = this.read(address);
        const hi = this.read((address + 1) & 0xFFFF);
        const value = (hi << 8) | lo;
        this.logger.log(3, () => `Read16 0x${padHex(value, 4)} from address 0x${padHex(address & 0xFFFF, 4)}`);
        return value;
    }

    push(value: number) {
        const stackAddr = 0x0100 + this.getSP();
        this.write(stackAddr, value);
        this.logger.log(3, () => `Push 0x${padHex(value, 2)} to stack at 0x${padHex(stackAddr, 4)}`);
        this.setSP((this.getSP() - 1) & 0xFF);
    }

    pull(): number {
        this.setSP((this.getSP() + 1) & 0xFF);
        const stackAddr = 0x0100 + this.getSP();
        const value = this.read(stackAddr);
        this.logger.log(3, () => `Pull 0x${padHex(value, 2)} from stack at 0x${padHex(stackAddr, 4)}`);
        return value;
    }
}